import React from "react";
import CountUp from "react-countup";

var bgimg1 = require("./../../images/background/bg-footer.png");
var bgimg2 = require("./../../images/background/bg-5.png");

class Statistics1 extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full overlay-wraper sx-bg-secondry mobile-page-padding  p-t80 p-b50 bg-parallax ml-auto"
          data-stellar-background-ratio="0.5"
          style={{
            backgroundImage: "url(" + bgimg1 + ")",
            objectPosition: "right bottom",
          }}
        >
          <div className="overlay-main " />
          <div className="container">
            <div className="section-content">
              <div className="counter-blocks">
                <div className="row">
                  <div className="col-xl-4 col-md-6 m-b30 ">
                    <div
                      className="sx-count text-white sx-icon-box-wraper bg-repeat p-a30"
                      style={{ backgroundColor: "#c5ac8e60" }}
                    >
                      <h2 className="m-t0 sx-text-primary text-center">
                        <span className="counter">
                          <CountUp end={2} duration={1} />+ Years
                        </span>
                      </h2>
                      <h4 className="m-b0 text-center">Our Experience</h4>
                    </div>
                  </div>
                  <div className="col-xl-4 col-md-6 m-b30">
                    <div
                      className="sx-count  text-white sx-icon-box-wraper bg-repeat p-a30"
                      style={{ backgroundColor: "#c5ac8e60" }}
                    >
                      <h2 className="m-t0  sx-text-primary text-center">
                        ~
                        <span className="counter">
                          <CountUp end={150} duration={2} />
                        </span>
                      </h2>
                      <h4 className="m-b0 text-center">Events Made Magical</h4>
                    </div>
                  </div>
                  <div className="col-xl-4 col-md-6 m-b30">
                    <div
                      className="sx-count text-white sx-icon-box-wraper bg-repeat p-a30"
                      style={{ backgroundColor: "#c5ac8e60" }}
                    >
                      <h2 className="m-t0 sx-text-primary text-center ">
                        ~
                        <span className="counter">
                          <CountUp end={1.5} duration={2} decimals={1} />
                        </span>
                        <span>K</span>
                      </h2>
                      <h4 className="m-b0 text-center">Instagram Followers</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Statistics1;
